import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { estados, useGetCepMutation } from '../../../services/cep.service';
import { RootState } from '../../../store';
import { Controller, useForm } from 'react-hook-form';
import { ICreateJourneyDTO } from '../../../Interfaces/PersonalData.interface';
import { savePersonalAddressData } from '../../../features/personalDataAddress/personalDataAddress-slice';
import MaskedInput from 'react-text-mask';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Divider } from '../../Address/ItemButton/styled';
import Stepper from '../Stepper';
import { WrapperActions } from '../ManagerStepper/styled';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLocation } from 'react-router-dom';
import useCreateJourneyRecurrentUser from '../../../domain/useCreateJourneyRecurrent';
import AlertMessage from '../../atoms/AlertMessage';
import PageLoading from '../Loading';
import { useRedirectToLandingPage } from '../../../domain/useRedirectToLandingPage';

export function OyanaAdress() {
  const { personalDataAddressInfo } = useSelector((state: RootState) => state);
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    register,
    control,
    trigger,
    getValues,
    setValue,
    formState: { errors }
  } = useForm<ICreateJourneyDTO>();
  const [getCepInfo, { data: dataCEP }] = useGetCepMutation();
  const { handleCreateJourneyRecurrent, errorJourney, isLoadingJourney } = useCreateJourneyRecurrentUser();
  const { handleRedirectToLandingPage } = useRedirectToLandingPage();
  const [valueSelect, setvalueSelect] = useState('');
  const [isValidForm, setIsValidForm] = useState(false);
  const handlerGetCep = () => {
    const cep = getValues('oyanaAddress.cep');
    trigger('oyanaAddress.cep');
    getCepInfo({ cep });
  };

  const handleChangeState = (value: string) => {
    saveAddress();
    setvalueSelect(value);
  };

  const saveAddress = () => {
    dispatch(
      savePersonalAddressData({
        cep: getValues('oyanaAddress.cep'),
        address: getValues('oyanaAddress.address'),
        addressNumber: getValues('oyanaAddress.addressNumber'),
        addressComplement: getValues('oyanaAddress.addressComplement'),
        addressReference: getValues('oyanaAddress.addressReference'),
        neighborhood: getValues('oyanaAddress.neighborhood'),
        city: getValues('oyanaAddress.city'),
        state: getValues('oyanaAddress.state'),
        isResidentialAddress: getValues('oyanaAddress.isResidentialAddress')
      })
    );
  };

  const isRedentialCheckebox = () => {
    const valueChecked = getValues('oyanaAddress.isResidentialAddress');
    if (!valueChecked) {
      setValue('oyanaAddress.isResidentialAddress', true);
    } else {
      setValue('oyanaAddress.isResidentialAddress', false);
    }
    triggerField('oyanaAddress.isResidentialAddress');
  };

  const handleSubmitForm = async () => {
    const isValid = await trigger();
    if (isValid) {
      saveAddress();
      setIsValidForm(true);
    }
  };

  const triggerField = async (field: string) => {
    const isValid = await trigger(field as any);
    if (isValid) {
      saveAddress();
    }
  };

  useEffect(() => {
    if (dataCEP) {
      setValue('oyanaAddress.address', dataCEP?.logradouro, { shouldValidate: true });
      setValue('oyanaAddress.neighborhood', dataCEP?.bairro, { shouldValidate: true });
      setValue('oyanaAddress.city', dataCEP?.localidade, { shouldValidate: true });
      if (dataCEP?.uf) {
        setValue('oyanaAddress.state', dataCEP.uf, { shouldValidate: true });
      }
      saveAddress();
    }
  }, [dataCEP]);

  useEffect(() => {
    if (isValidForm) {
      handleCreateJourneyRecurrent({
        token: location.state.token
      });
    }
  }, [isValidForm]);

  useEffect(() => {
    if (personalDataAddressInfo.state.length > 0) {
      setvalueSelect(personalDataAddressInfo.state);
      setValue('oyanaAddress.state', personalDataAddressInfo.state, { shouldValidate: true });
    }
  }, [personalDataAddressInfo]);

  return (
    <>
      {isLoadingJourney && <PageLoading />}
      <form onSubmit={e => e.preventDefault()} autoComplete="on">
        {errorJourney && (
          <AlertMessage
            text={'Não conseguimos criar sua jornada, tente novamente mais tarde.'}
            textButton="Entendi"
            type="error"
            handler={() => {
              handleRedirectToLandingPage();
            }}
          />
        )}

        <Box>
          <Box sx={{ mb: 4 }}>
            <Stepper separator="de" text="Dados pessoais" />
          </Box>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h3">Onde você vai estar? Digite abaixo o seu endereço</Typography>
          </Box>
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            CEP*
          </Typography>

          <Controller
            name="oyanaAddress.cep"
            control={control}
            rules={{
              required: 'Campo obrigatório'
            }}
            render={() => (
              <MaskedInput
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                className="form-control"
                guide={false}
                id="oyanaAddress.cep"
                defaultValue={personalDataAddressInfo.cep}
                render={(ref, props) => (
                  <TextField
                    {...props}
                    inputRef={ref}
                    id="cep"
                    helperText={errors?.oyanaAddress?.cep?.message}
                    error={errors?.oyanaAddress?.cep && true}
                    type="tel"
                    autoComplete="postal-code"
                    variant="standard"
                    inputProps={{
                      maxLength: 9,
                      classes: {
                        input: 'multilineColor'
                      },
                      'data-testid': 'cep'
                    }}
                    fullWidth
                    placeholder="00000-000"
                    {...register('oyanaAddress.cep', {
                      onBlur: () => {
                        handlerGetCep();
                        saveAddress();
                      },
                      required: 'Campo Obrigatório'
                    })}
                  />
                )}
              />
            )}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Endereço*
          </Typography>
          <TextField
            id="address"
            defaultValue={dataCEP?.logradouro || personalDataAddressInfo.address}
            helperText={errors?.oyanaAddress?.address?.message}
            error={errors?.oyanaAddress?.address && true}
            type="text"
            autoComplete="address-line1"
            variant="standard"
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'address'
            }}
            fullWidth
            {...register('oyanaAddress.address', {
              onChange: e => {
                setValue('oyanaAddress.address', e.target.value);
                triggerField('oyanaAddress.address');
              },
              required: 'Campo Obrigatório'
            })}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Número*
          </Typography>
          <TextField
            id="addressNumber"
            helperText={errors?.oyanaAddress?.addressNumber?.message}
            error={errors?.oyanaAddress?.addressNumber && true}
            type="text"
            autoComplete="address-line2"
            variant="standard"
            defaultValue={personalDataAddressInfo.addressNumber}
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'addressNumber'
            }}
            fullWidth
            {...register('oyanaAddress.addressNumber', {
              onChange(event) {
                setValue('oyanaAddress.addressNumber', event.target.value);
                triggerField('oyanaAddress.addressNumber');
              },
              maxLength: 10,
              required: 'Campo Obrigatório'
            })}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Complemento
          </Typography>
          <TextField
            id="addressComplement"
            helperText={errors?.oyanaAddress?.addressComplement?.message}
            error={errors?.oyanaAddress?.addressComplement && true}
            type="text"
            variant="standard"
            defaultValue={personalDataAddressInfo.addressComplement}
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'addressComplement',
              maxLength: 100
            }}
            fullWidth
            placeholder="apartamento / casa / quadra"
            {...register('oyanaAddress.addressComplement', {
              maxLength: 100,
              onChange: () => saveAddress()
            })}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Ponto de Referência
          </Typography>
          <TextField
            id="addressReference"
            helperText={errors?.oyanaAddress?.addressReference?.message}
            error={errors?.oyanaAddress?.addressReference && true}
            type="text"
            variant="standard"
            defaultValue={personalDataAddressInfo.addressReference}
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'addressReference'
            }}
            fullWidth
            {...register('oyanaAddress.addressReference', {
              onChange: () => saveAddress(),
              maxLength: 60
            })}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Bairro*
          </Typography>
          <TextField
            id="neighborhood"
            defaultValue={dataCEP?.bairro || personalDataAddressInfo.neighborhood}
            helperText={errors?.oyanaAddress?.neighborhood?.message}
            error={errors?.oyanaAddress?.neighborhood && true}
            type="text"
            autoComplete="address-line3"
            variant="standard"
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'neighborhood'
            }}
            fullWidth
            {...register('oyanaAddress.neighborhood', {
              onChange: e => {
                setValue('oyanaAddress.neighborhood', e.target.value);
                triggerField('oyanaAddress.neighborhood');
              },
              required: 'Campo Obrigatório'
            })}
          />
        </Box>
        <Box sx={{ mb: 7 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Cidade*
          </Typography>
          <TextField
            id="city"
            defaultValue={dataCEP?.localidade || personalDataAddressInfo.city}
            helperText={errors?.oyanaAddress?.city?.message}
            error={errors?.oyanaAddress?.city && true}
            type="text"
            autoComplete="address-line4"
            variant="standard"
            inputProps={{
              classes: {
                input: 'multilineColor'
              },
              'data-testid': 'city'
            }}
            fullWidth
            {...register('oyanaAddress.city', {
              onChange: e => {
                setValue('oyanaAddress.city', e.target.value);
                triggerField('oyanaAddress.city');
              },
              required: 'Campo Obrigatório'
            })}
          />
        </Box>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body6" sx={{ mb: 0.5 }}>
            Estado*
          </Typography>
          <Select
            error={errors?.oyanaAddress?.state && true}
            id="state"
            variant="standard"
            value={dataCEP?.uf ? dataCEP.uf : valueSelect}
            fullWidth
            defaultValue={personalDataAddressInfo.state}
            {...register('oyanaAddress.state', {
              onChange: e => {
                setValue('oyanaAddress.state', e.target.value);
                handleChangeState(e.target.value);
                triggerField('oyanaAddress.state');
              },
              maxLength: 60,
              required: 'Campo Obrigatório',
              pattern: {
                value: /(^[a-zA-Z ]*$)/,
                message: 'Estado inválido'
              }
            })}
            inputProps={{
              'data-testid': 'state',
              MenuProps: {
                sx: {
                  '&& .Mui-selected': {
                    backgroundColor: theme.palette.neutrals.beige3
                  },
                  '& .MuiMenuItem-root:hover': {
                    backgroundColor: theme.palette.neutrals.beige3
                  }
                },
                MenuListProps: {
                  sx: {
                    backgroundColor: theme.palette.neutrals.beige2
                  }
                }
              }
            }}
          >
            {estados.map(estado => (
              <MenuItem key={estado.uf} value={estado.uf}>
                {estado.nome}
              </MenuItem>
            ))}
          </Select>
          {errors?.oyanaAddress?.state && <FormHelperText error>{errors?.oyanaAddress.state?.message}</FormHelperText>}
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <FormControlLabel
                label=""
                sx={{ marginRight: '1px' }}
                control={
                  <Controller
                    control={control}
                    name="oyanaAddress.isResidentialAddress"
                    defaultValue={
                      personalDataAddressInfo.isResidentialAddress ? personalDataAddressInfo.isResidentialAddress : false
                    }
                    rules={{ required: false }}
                    render={({ field: { onChange, value, ref } }) => (
                      <Checkbox
                        inputProps={
                          {
                            marginLeft: 10
                          } as React.InputHTMLAttributes<HTMLInputElement>
                        }
                        onBlur={() => trigger('oyanaAddress.isResidentialAddress')}
                        onChange={onChange}
                        checked={value}
                        inputRef={ref}
                      />
                    )}
                  />
                }
              />
            </Box>
            <Box onClick={() => isRedentialCheckebox()} sx={{ cursor: 'pointer' }}>
              <Typography variant="body2R">Este é o meu endereço residencial</Typography>
            </Box>
          </Box>
          <Divider />
        </Box>
        <WrapperActions sx={{ flexDirection: 'column', alignItems: 'flex-end' }}>
          <LoadingButton
            variant="contained"
            onClick={handleSubmitForm}
            disabled={false}
            sx={{ padding: '12px 16px 14px 24px' }}
          >
            <Typography variant="body1" sx={{ mr: 1.5 }}>
              Continuar
            </Typography>
            <ArrowForwardIcon />
          </LoadingButton>
        </WrapperActions>
      </form>
    </>
  );
}
